import { ApiRoutes } from '@/constant/api';

import { api } from '@/shared/helpers/axios';

export const servicesApi = {
	isAvailableFoodService: () =>
		api.get(`${ApiRoutes.Service}/food`).then((res) => res.data as boolean),
};
